import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { HashLink as Link } from 'react-router-hash-link';

const ActionCard = ({ icon, excerpt, caption, actionText, actionPath }) => {
  const [active, setActive] = useState(true);
  const isActive = (prop) => (prop ? 'actioncard_compact' : 'actioncard_full');
  const buttonRef = useRef();

  return (
    <div
      ref={buttonRef}
      role="button"
      tabIndex={0}
      onKeyPress={() => {
        setActive(!active);
      }}
      onTouchStart={(e) => {
        e.preventDefault();
        buttonRef.current.style = 'pointer-events: none';
        setTimeout(() => {
          buttonRef.current.style = 'pointer-events: auto';
        }, 300);
        setActive(!active);
      }}
      onMouseEnter={() => {
        setActive(!active);
      }}
      onMouseLeave={() => {
        setActive(!active);
      }}
      className={`actioncard ${isActive(active)} fadeIn animated`}
    >
      <div className="actioncard__media">
        {active && <img src={icon} alt="" className="actioncard__icon" />}
      </div>

      {active ? (
        <div
          className="fs-p actioncard__caption"
          dangerouslySetInnerHTML={{ __html: excerpt }}
        ></div>
      ) : (
        <div
          className="fs-p actioncard__caption"
          dangerouslySetInnerHTML={{ __html: caption }}
        ></div>
      )}

      <div className="actioncard__action">
        {!active && (
          <Link to={actionPath} className="fs-sm srp-button srp-button__rev">
            {actionText}
          </Link>
        )}
      </div>
    </div>
  );
};

ActionCard.propTypes = {
  icon: PropTypes.any.isRequired,
  excerpt: PropTypes.string.isRequired,
  caption: PropTypes.string.isRequired,
  actionText: PropTypes.string.isRequired,
  actionPath: PropTypes.string.isRequired,
};

export default ActionCard;
